function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function t(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var n = {
    splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
    matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
    replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
  },
  r = {
    splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
    matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
    replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
  },
  a = {
    splitReg: "\\\\?\\*\\\\?\\*(?:[^\\s]+?|[^\\s].+?[^\\s])(?:\\\\\\*\\\\\\*|\\*\\*+)",
    matchReg: /\*\*([^\s]+|[^\s].+[^\s])\*\*$/,
    replaceReg: "\\\\\\*\\\\\\*([^\\s]+|[^\\s].+[^\\s])\\\\\\*\\\\\\*"
  },
  o = {
    splitReg: "\\\\n|\\n",
    matchReg: /\n/,
    replaceReg: /\\n/
  },
  c = {
    splitReg: "%\\[[^\\]]+\\]\\([^)]+\\)",
    matchReg: /%\[([^\]]+)\]\(([^)]+)\)/,
    replaceReg: "(%\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
  },
  i = function i(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return ["text", "span", "a", "strong"].indexOf(e) > -1 && (n.style || (n.style = {}), n.style["white-space"] || (n.style["white-space"] = "break-spaces")), {
      tagName: e,
      content: t,
      property: n
    };
  },
  l = function l(e, t, n, r) {
    return t + (n ? n.slice(1) : "") + r;
  };
function p(e) {
  return (p = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}
var g = function g(e, t, n) {
    if ("string" != typeof e || !e) return "";
    if (!t || "object" !== p(t)) return e;
    return e.replace(/{{\s*([^}\s]+)\s*}}/g, function (e, r) {
      if (void 0 !== t[r]) {
        var a = t[r];
        return "function" == typeof n ? n(a) : a;
      }
      return e;
    });
  },
  s = function () {
    function p() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, p), t(this, "formatString", function (e, t) {
        return t && t.variable ? g(e, t.variable, t.handleVariable) : e;
      }), t(this, "handleStrong", function (e, t) {
        var n = t.match(e);
        return i("strong", n[1]);
      }), t(this, "handleStrongReplace", function (e, t) {
        var n = t.replace(new RegExp(e, "g"), "**$1**");
        return i("text", n);
      });
    }
    var s, u, f;
    return s = p, (u = [{
      key: "getTextContent",
      value: function value(e, t) {
        return this.parseToTagConfig(e, t).map(function (e) {
          return e.content;
        }).join("");
      }
    }, {
      key: "parseToTagConfig",
      value: function value(e, t) {
        var p = this,
          g = [],
          s = r,
          u = n,
          f = a,
          R = o,
          h = c;
        if (!e || 0 !== e.indexOf("$RT$")) return [i("text", e)];
        e = (e = this.formatString(e, t)).slice("$RT$".length);
        var m = "(".concat(u.splitReg, ")|(").concat(s.splitReg, ")|(").concat(f.splitReg, ")|(").concat(R.splitReg, ")|(").concat(h.splitReg, ")");
        return e.split(new RegExp(m)).filter(function (e) {
          return !!e;
        }).forEach(function (e) {
          var t;
          if (new RegExp(u.matchReg).test(e)) {
            var n = e.match(u.matchReg);
            t = i("img", "", {
              alt: n[1],
              src: n[2]
            });
          } else if (new RegExp(h.matchReg).test(e)) {
            var r = e.match(h.matchReg);
            t = i("span", r[1], {
              style: {
                color: r[2]
              }
            });
          } else if (new RegExp(s.matchReg).test(e)) {
            var a = e.match(s.matchReg);
            t = i("a", a[1], {
              href: a[2],
              target: "_blank",
              rel: "noopener"
            });
          } else if (f.matchReg.test(e)) t = p.handleStrong(f.matchReg, e);else if (new RegExp(u.replaceReg).test(e)) {
            var o = e.replace(new RegExp(u.replaceReg, "g"), l);
            t = i("text", o);
          } else if (new RegExp(h.replaceReg).test(e)) {
            var c = e.replace(new RegExp(h.replaceReg, "g"), l);
            t = i("span", c);
          } else if (new RegExp(s.replaceReg).test(e)) {
            var m = e.replace(new RegExp(s.replaceReg, "g"), l);
            t = i("text", m);
          } else t = new RegExp(f.replaceReg).test(e) ? p.handleStrongReplace(f.replaceReg, e) : new RegExp(R.replaceReg).test(e) ? i("text", "\\n") : new RegExp(R.matchReg).test(e) ? i("br", "") : i("text", e);
          g.push(t);
        }), g;
      }
    }, {
      key: "parseToDom",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = document.createElement(t);
        return e.forEach(function (e) {
          var t = document.createElement("text" === e.tagName ? "span" : e.tagName);
          t.textContent = e.content, e.property && Object.keys(e.property).forEach(function (n) {
            var r = e.property[n];
            if ("style" === n && "[object Object]" === Object.prototype.toString.call(r) && r) {
              var a = Object.keys(r).map(function (e) {
                return "".concat(e, ":").concat(r[e]);
              });
              r = a.join(";");
            }
            t.setAttribute(n, r);
          }), n.appendChild(t);
        }), n;
      }
    }, {
      key: "autoParseToDom",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = this.parseToTagConfig(e, n);
        return this.parseToDom(r, t);
      }
    }]) && e(s.prototype, u), f && e(s, f), p;
  }();
export { s as RichText, g as formatVar };